import React from 'react';
import { Form } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { Input, Select, WysiwygField } from '../../components/Form'
import { isURL, required } from '../../validators';
import { AdDuration } from '../../api/ads';
import { INewsItem } from '../../api/news';
import { IGroup } from '../../api/groups';
import BoolSelect from '../../components/Form/BoolSelect';

interface IProps {
  item: INewsItem;
  groups: IGroup[];

  save: (values: any) => void;
  saving: boolean;
  remove: (id: number) => void;
  removing: boolean;
}

export default function NewsOverview(props: IProps) {
  const {
    item,
    save,
    saving,
    remove,
    removing,
    groups
  } = props;

  const initial = {
    ...item,
    groups: item.groups?.map((g: any) => g.id)
  };

  const handleSubmit = (values: any) => {
    save({
      ...values,
      groups: values.groups?.map((id: number) => ({ id: Number(id) })) || [],
      id: item.id,
      name: values.title
    });
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={initial}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit} style={{ position: 'relative' }}>
          <Input
            name="title"
            label="Заголовок"
            validate={required}
            margin="normal"
          />
          <WysiwygField name="shortText" label="Анонс" />
          <WysiwygField name="mainText" label="Текст" />

          <Select
            name="showDuration"
            label="Длительность показа"
            options={Object.values(AdDuration).map((f) => ({ value: f, label: f }))}
            fullWidth
            validate={required}
            margin="normal"
          />

          <Input name="source"
            label="Источник (URL)"
            margin="normal"
            validate={isURL}
            placeholder="https://site.com/news/1"
            emptyAsNull />
          <Select name="groups"
            label="Группы"
            options={groups?.map((g) => ({ value: g.id, label: g.name }))}
            fullWidth
            margin="normal"
            multi />
          <BoolSelect name="pinned" label="Закреплена" margin="normal" addEmpty={false} fullWidth={true} />
          <BoolSelect name="active" label="Активна" margin="normal" addEmpty={false} fullWidth={true} />
          <Grid container justify="space-between" style={{ position: 'sticky', bottom: 0 }}>
            <Grid item>
              <Box my={2}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={saving}
                >
                  {item.id ? 'Сохранить' : 'Создать новость'}
                </Button>
              </Box>
            </Grid>

            {item.id && (
              <Grid item>
                <Box my={2}>
                  <Button
                    variant="contained"
                    size="large"
                    className="deleteButton"
                    disabled={removing}
                    onClick={() => remove(item.id)}
                  >
                    Удалить
                  </Button>
                </Box>
              </Grid>
            )}
          </Grid>

        </form>
      )}
    />
  );
}